import { request } from "../../service/api";
import { OPTION_TYPES, SUPPORT_LIST } from "../../constants";
import type { ApiEnvelope, ApplicationPageOption, CloneQuestionsPayload, SaveQuestionsPayload, SupportQuestionsData, SupportTopic } from "./types";

// ---- Read endpoints ----

export function fetchSupportQuestions(supportDataId: string | number): Promise<ApiEnvelope<SupportQuestionsData>> {
  return request(`${SUPPORT_LIST}/${supportDataId}`, { method: "GET" });
}

export function fetchApplicationPageOptions(): Promise<ApiEnvelope<{ options: ApplicationPageOption[] }>> {
  return request(`${OPTION_TYPES}/applicationpage`, { method: "GET" });
}

export function fetchSupportTopics(payload: { page?: string; application?: string }): Promise<ApiEnvelope<SupportTopic[]>> {
  return request(`/supporttopics?page=${payload.page ?? ""}&application=${payload.application ?? ""}`, { method: "GET" });
}

// ---- Mutation endpoints ----

export function saveSupportQuestions(payload: SaveQuestionsPayload): Promise<ApiEnvelope<void>> {
  return request(`${SUPPORT_LIST}/${payload.id}/questions`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function cloneSupportQuestions(payload: CloneQuestionsPayload): Promise<ApiEnvelope<void>> {
  const body = { id: payload.id, replaceQuestions: payload.replaceQuestions };
  return request(`${SUPPORT_LIST}/${payload.supportDataId}/clone`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
